module.exports = __webpack_public_path__ + "img/kapian.415808fe.png";